
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { LayoutItemProps } from ".";
import { loading, update } from "store/layout";
import { AppMessage } from "components";

interface ApiLayoutUpdateInputProps extends LayoutItemProps {
}

type ApiLayoutUpdateOutputProps = OutputBaseProps<{ item: LayoutItemProps; }, ApiLayoutUpdateInputProps>

export const apiLayoutUpdate = async (data: ApiLayoutUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiLayoutUpdateOutputProps>("/api/layout/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};